import { render, staticRenderFns } from "./ModalPatientPDF.vue?vue&type=template&id=088b7e90&scoped=true"
import script from "./ModalPatientPDF.vue?vue&type=script&lang=js"
export * from "./ModalPatientPDF.vue?vue&type=script&lang=js"
import style0 from "./ModalPatientPDF.vue?vue&type=style&index=0&id=088b7e90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088b7e90",
  null
  
)

export default component.exports